<template>
    <section class="overview">
        <div>

            <div class="header">The key ingredients of modern voice services</div>
            <div class="content">
                <div>
                    <h2>IMS core</h2>
                    <p>The IP Multimedia Subsystem (IMS) comprises network elements with functions and interfaces standardized by the 3GPP and other standards bodies.</p>
                    <p>The IMS supports voice calls over any IP interface. The GSM Association specifies “IMS profiles” that enable CSPs to build interoperable networks more easily.</p>
                    <button class="button arrow" @click="goToStep(2, 1)">Discover more</button>
                </div>
                <div>
                    <h2>Access agnostic</h2>
                    <p>IMS supports voice services over any type of access – fixed, cable, 2G/3G/4G and any type of 5G deployment.</p>
                    <p>In 5G, an IMS network is essential to handle voice services. This means the roll out of 5G is accelerating the modernization of older core network technologies to IMS.</p>
                    <button class="button arrow" @click="goToStep(3, 1)">Discover more</button>
                </div>
                <div>
                    <h2>Architectural evolution</h2>
                    <p>Voice over 5G (Vo5G) is typically implemented in one of two ways, according to the approach adopted by the CSP when deploying a 5G network. This governs the network’s architectural evolution.</p>
                    <button class="button arrow" @click="goToStep(4, 1)">Discover more</button>
                </div>
                <div>
                    <h2>Use cases</h2>
                    <p>5G enables a wide variety of use cases, so voice needs the same flexibility. Open Application Programming Interfaces (APIs) enable voice services to evolve within the IMS ecosystem.</p>
                    <p>Open APIs can customize call logic and create new capabilities to enable innovative, revenue-winning services.</p>
                    <button class="button arrow" @click="goToStep(5, 1)">Discover more</button>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

    export default {
        methods: {
            goToStep(chapter, step) {
                this.$emit('goToStepCalled', chapter, step);
            }
        }
    }

</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .overview {
        background: white;
        z-index: 1;

        > div {
            display: flex;
            flex-direction: column;
        }

        .header {
            background: $color-blue;
            height: 110px;
            display: flex;
            align-items: center;
            padding: 0 30px;
            font-size: 3rem;
            color: white;
        }

        .content {
            flex: 1 0 auto;
            display: flex;
            flex-wrap: wrap;

            button {
                position: absolute;
                bottom: 40px;
            }

            h2 {
                color: #001135;
                font-size: 4rem;
                line-height: 4.4rem;
            }

            p {
                color: #001135;
            }

            > div {
                width: 50%;
                padding: 30px;
                position: relative;

                &:nth-child(1),
                &:nth-child(4) {
                    background: $color-gray;
                }
            }
        }

        @include custom-breakpoint(1000) {

            .content {
                flex-direction: column;

                > div {
                    width: 100%;
                    padding: 20px;
                }
            }
        }
    }

</style>